import { BaseLessonSchema, QuizPin, QuizPinSchema, SlidePinSchema } from '@lessonup/pins-shared';
import { z } from 'zod';

// Original: https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/assignment/Assignment.ts

export type SlidePin = z.infer<typeof SlidePinSchema>;
export const DbAssignmentPinSchema = z.discriminatedUnion('type', [QuizPinSchema, SlidePinSchema]);

export const DbAssignmentSchema = BaseLessonSchema.omit({ user: true }).extend(
  z.object({
    ownerId: z.string(),
    pins: z.record(z.string(), DbAssignmentPinSchema),
    createdAt: z.number(),
    modifiedAt: z.number(),
  }).shape
);

export type DbAssignment = z.infer<typeof DbAssignmentSchema>;

export function isOwnerOfAssignment(userId: string, assignment: DbAssignment): boolean {
  return assignment.ownerId === userId;
}
